import React from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {toast, ToastContainer} from 'react-toastify';
import {withStyles} from '@material-ui/core/styles';
import {SignUp} from "aws-amplify-react";
import {I18n} from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import AmplifyTheme from '../../themes/AmplifyTheme';
import CssBaseline from '@material-ui/core/CssBaseline';

import Logo from "../../assets/img/logo-square-on-white.svg";

class CustomSignUp extends SignUp
{
    constructor(props)
    {
        super(props);
        this._validAuthStates = ['signUp'];
        this.signUp = this.signUp.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.state = {
            username: '',
            password: '',
            eMailisValid: false,
            emailFormat: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        }
    }

    handleInputChange(event)
    {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        switch (name)
        {
            case 'username':
                if (this.state.emailFormat.test(String(value).toLowerCase()))
                {
                    this.setState({eMailisValid: true});
                } else
                {
                    this.setState({eMailisValid: false});
                }
                this.setState({username: value});
                break;
            case 'password':
                this.setState({password: value})
                break;
            default:
                break;
        }
    }

    signUp(e)
    {
        e.preventDefault();
        let signup_info = {
            username: this.state.username.toLowerCase(),
            password: this.state.password,
        };
        Auth.signUp(signup_info).then((data) =>
        {
            this.changeState('confirmSignUp', data.user.username)
        })
            .catch((err) =>
            {
                switch (err.code)
                {
                    case 'InvalidParameterException':
                        toast.error("Das Kennwort entspricht nicht den Richtlinien (mindestens 8 Zeichen).")
                        break;
                    case 'UsernameExistsException':
                        toast.error("Ein Konto mit dieser E-Mail Adresse existiert bereits.")
                        break;
                    default:
                        toast.error("Es ist ein unbekannter Fehler aufgetreten. Bitte kontaktieren Sie den Support.")
                        break;
                }
            });
    }

    showComponent()
    {
        const {classes} = this.props;
        return (
            <MuiThemeProvider theme={AmplifyTheme}>
                <CssBaseline/>
                <div className={classes.main}>
                    <ToastContainer/>
                    <Paper className={classes.paper}>
                        <img src={Logo} width="200" height="200" alt="QRsticker logo"/>
                        <Typography component="h1" variant="h5" className={classes.title}>
                            {I18n.get('Registrieren')}
                        </Typography>
                        <form className={classes.form} onSubmit={this.signUp}>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="username">{I18n.get('E-Mail Adresse')}</InputLabel>
                                <Input id="username" key="username" name="username" type="email" autoComplete="email" autoFocus autoCorrect="off"
                                       autoCapitalize="off" spellCheck="false" onChange={this.handleInputChange}/>
                                {(!this.state.eMailisValid) &&
                                    <FormHelperText id="component-error-text">Bitte geben Sie eine gültige E-Mail Adresse ein.</FormHelperText>
                                }
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="password">{I18n.get('Password')}</InputLabel>
                                <Input name="password" key="password" type="password" id="password" autoComplete="current-password"
                                       onChange={this.handleInputChange}/>
                                {(this.state.password === "" || this.state.password.length < 8) &&
                                    <FormHelperText id="component-error-text">Das Passwort muss mindestens 8 Zeichen lang sein.</FormHelperText>
                                }
                            </FormControl>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="secondary"
                                className={classes.submit}
                                disabled={!this.state.eMailisValid || this.state.password.length < 8}>
                                {I18n.get('Registrieren')}
                            </Button>
                            <hr/>
                            <Typography>{I18n.get('Sie sind schon registriert?')}</Typography>
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={() => this.changeState('signIn')}>
                                {I18n.get('Sign In')}
                            </Button>
                        </form>
                    </Paper>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default withStyles(AmplifyTheme)(CustomSignUp);
